function getDateFromTimestamp(timestamp) {
  const dateTime = timestamp.split('T')
  const dateDetails = dateTime[0].split('-')
  const timeDetails = dateTime[1].split(':')
  // New Date(year, month, date, hour,minute, seconds, milliseconds)
  return new Date(
    dateDetails[0],
    dateDetails[1] - 1,
    dateDetails[2],
    timeDetails[0],
    timeDetails[1],
    timeDetails[2],
    0
  )
}

function adjustDateToGMT(date, offset) {
  const minutes = parseInt(offset.substring(offset.length - 2), 10)
  const hours = parseInt(offset.substring(0, offset.length - 2), 10)
  const offsetNegativeMultiplier = offset.substring(0, 1) === '-' ? -1 : 1
  const milliseconds = hours * 60 * 60 * 1000 + offsetNegativeMultiplier * minutes * 60 * 1000
  return new Date(date.getTime() - milliseconds)
}

function diffInHours(date1, date2) {
  const date1Milliseconds = date1.getTime()
  const date2Milliseconds = date2.getTime()
  return (date1Milliseconds - date2Milliseconds) / (60 * 60 * 1000)
}

export default function getFreeCancellationMessage(voidWindowInfo) {
  let cancellationMessage = null
  try {
    const clientGMTDate = getDateFromTimestamp(voidWindowInfo.clientUTCDateTime)
    const voidWindowDate = getDateFromTimestamp(voidWindowInfo.timeStamp)
    const voidWindowDateGMT = adjustDateToGMT(voidWindowDate, voidWindowInfo.tzDesignator)
    let hoursLeft = Math.floor(diffInHours(voidWindowDateGMT, clientGMTDate))
    if (hoursLeft > 24) {
      hoursLeft = 24
    }
    if (hoursLeft > 0) {
      cancellationMessage = `No risk! Book now and cancel online for free within ${hoursLeft} ${
        hoursLeft === 1 ? 'hour' : 'hours'
      }.`
    }
  } catch (err) {
    cancellationMessage = null
  }
  return cancellationMessage
}
